import { Component } from 'react';
import { Alert, Button, Card, Image, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Cultured, DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { getUrlParam } from '../../helpers/general_helpers';
import axios from 'axios';
import GetIcon from '../../helpers/icon_helper';
import PaymentGatewayJisHyperpay from './PaymentGatewayJisHyperpay';
import PaymentGatewayMastercard from './PaymentGatewayMastercard';
import PaymentGatewayRosom from './PaymentGatewayRosom';
import PaymentGatewayStreampay from './PaymentGatewayStreampay';
const apiURL = process.env.REACT_APP_API_URL;

class PaymentGateway extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageReady: false,
      isPageError: false,
      params: null,
      tenant_id: null,
      rData: null
    };
  }

  componentDidMount() {
    let getUrlParamData = getUrlParam()
    if (getUrlParamData.p || getUrlParamData.rData || getUrlParamData.orderId || getUrlParamData.resultIndicator || getUrlParamData.center_id || getUrlParamData.sadadNumber || getUrlParamData.invoiceId || getUrlParamData.payment_id || getUrlParamData.payment_link_id) {
      let data = getUrlParamData.p ? JSON.parse(decodeURIComponent(atob(getUrlParamData.p))) : null;
      if (!data && (getUrlParamData.orderId || getUrlParamData.resultIndicator || getUrlParamData.center_id || getUrlParamData.sadadNumber || getUrlParamData.invoiceId || getUrlParamData.payment_id || getUrlParamData.payment_link_id)) {
        data = {
          center_id: parseInt(getUrlParamData.center_id || 2),
          child_id: getUrlParamData.child_id,
          parent_id: getUrlParamData.parent_id,
          user_id: getUrlParamData.user_id,
          actionType: getUrlParamData.actionType,
          orderId: getUrlParamData.orderId,
          payment_id: getUrlParamData.payment_id || getUrlParamData.id,
          payment_link_id: getUrlParamData.payment_link_id,
          resultIndicator: getUrlParamData.resultIndicator,
          sadadNumber: getUrlParamData.sadadNumber || getUrlParamData.sadad_number,
          invoiceId: getUrlParamData.invoiceId,
        };
      }
      let tenant_id = getUrlParamData.tenant_id ? getUrlParamData.tenant_id : null;
      let rData = getUrlParamData.rData ? JSON.parse(decodeURIComponent(atob(getUrlParamData.rData))) : null;
      this.setState({ params: data, tenant_id, rData }, () => this.getDetails())
    } else {
      this.setState({ isPageReady: true, isPageError: true })
    }
  }

  getDetails = () => {
    try {
      if (!this.state.params || !this.state.params.center_id) {
        this.setState({ isPageReady: true, isPageError: true });
        return;
      }
      axios.get(apiURL + 'payment-gateway/get-details', {
        params: {
          center_id: this.state.params.center_id,
          child_id: this.state.params.child_id,
          parent_id: this.state.params.parent_id,
          tenant_id: this.state.tenant_id,
        }
      }).then((res) => {
        if (res) {
          let resData = res.data
          if (resData.type) {
            this.setState({ params: { ...this.state.params, ...resData.data }, isPageReady: true })
          } else {
            if (this.state.params && (this.state.params.orderId || this.state.params.resultIndicator)) {
              this.setState({ isPageReady: true, isPageError: false });
            } else {
              this.setState({ isPageReady: true, isPageError: true });
            }
          }
        }
      }).catch(() => {
        if (this.state.params && (this.state.params.orderId || this.state.params.resultIndicator)) {
          this.setState({ isPageReady: true, isPageError: false });
        } else {
          this.setState({ isPageReady: true, isPageError: true });
        }
      });
    } catch (e) {
      if (this.state.params && (this.state.params.orderId || this.state.params.resultIndicator)) {
        this.setState({ isPageReady: true, isPageError: false });
      }
    }
  }

  renderCenterPaymentPage = () => {
    // PaymentGatewayJisHyperpay
    // PaymentCenterDefault
    // PaymentNotConfigured
    let { params, tenant_id } = this.state
    if (params.center_id === 2) {
      return <PaymentCenterDefault params={params} tenant_id={tenant_id} />
    }
    // else if ([2, 509].includes(params.center_id)) {
    //   return <PaymentGatewayRosom params={params} tenant_id={tenant_id} />
    // } else if ([509].includes(params.center_id)) {
    //   return <PaymentGatewayStreampay params={params} tenant_id={tenant_id} />
    // } else if ([501, 502, 512].includes(params.center_id)) {
    //   return <PaymentGatewayMastercard params={params} tenant_id={tenant_id} />
    // }
    else if ([83, 503].includes(params.center_id)) {
      return <PaymentGatewayJisHyperpay params={params} tenant_id={tenant_id} />
    } else {
      return <PaymentNotConfigured params={params} tenant_id={tenant_id} />
    }
  }

  render() {
    let { isPageReady, isPageError, rData } = this.state
    return (
      <div style={{ backgroundColor: Cultured, minHeight: '100vh', width: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className='d-flex flex-column align-items-center justify-content-center' style={{ width: '100%', minHeight: '100vh', padding: '24px 16px', fontSize: 14 }}>

          {/* IF RETURN DATA FROM SERVER AFTER PAYMENT */}
          {(rData) &&
            <Card
              className='border-0 shadow-sm'
              style={{
                borderRadius: '20px',
                width: '100%',
                maxWidth: 500,
                backgroundColor: White,
                overflow: 'hidden'
              }}
            >
              <Card.Header
                className='py-3'
                style={{
                  backgroundColor: White,
                  borderBottom: '1px solid #f0f0f0',
                  textAlign: 'center'
                }}
              >
                <div style={{ color: DarkElectricBlue, fontSize: 18, fontWeight: 700 }}>
                  {t(rData.messageTitle || (rData.type ? 'Payment Successful' : 'Payment Status'))}
                </div>
              </Card.Header>

              <Card.Body className='text-center px-4 py-4'>
                <div className='my-3'>
                  <GetIcon
                    icon={rData.type ? 'LuBadgeCheck' : 'LuBadgeAlert'}
                    style={{
                      fontSize: 72,
                      color: rData.type ? '#28a745' : '#dc3545'
                    }}
                  />
                </div>

                <h4
                  className='mb-2'
                  style={{
                    color: rData.type ? '#28a745' : '#dc3545',
                    fontWeight: 700
                  }}
                >
                  {t(rData.type ? 'Payment Completed!' : 'Payment Incomplete')}
                </h4>

                <p className='text-muted mb-4' style={{ fontSize: 14, lineHeight: 1.6 }}>
                  {t(rData.message)}
                </p>

                {/* Details Breakdown */}
                {(rData.orderId || rData.paymentId || rData.amount || this.state.params?.child_name) && (
                  <div
                    className='p-3 mb-4 text-start'
                    style={{
                      backgroundColor: '#f8f9fa',
                      borderRadius: '12px',
                      fontSize: 13
                    }}
                  >
                    {this.state.params?.child_name && (
                      <div className='d-flex justify-content-between py-1'>
                        <span className='text-muted'>{t('Student Name')}</span>
                        <span style={{ fontWeight: 600, color: DarkElectricBlue }}>{this.state.params.child_name}</span>
                      </div>
                    )}
                    {rData.orderId && (
                      <div className='d-flex justify-content-between py-1 border-top'>
                        <span className='text-muted'>{t('Order ID')}</span>
                        <span style={{ fontWeight: 600, color: DarkElectricBlue }}>{rData.orderId}</span>
                      </div>
                    )}
                    {rData.paymentId && (
                      <div className='d-flex justify-content-between py-1 border-top'>
                        <span className='text-muted'>{t('Payment Reference')}</span>
                        <span style={{ fontWeight: 600, color: DarkElectricBlue }}>{rData.paymentId}</span>
                      </div>
                    )}
                    {(rData.amount || this.state.params?.balance) && (
                      <div className='d-flex justify-content-between py-1 border-top'>
                        <span className='text-muted'>{t('Amount')}</span>
                        <span style={{ fontWeight: 700, color: '#28a745' }}>
                          {(rData.amount || this.state.params?.balance)} {rData.currency || this.state.params?.currencycode || 'SAR'}
                        </span>
                      </div>
                    )}
                    <div className='d-flex justify-content-between py-1 border-top'>
                      <span className='text-muted'>{t('Status')}</span>
                      <span className={`badge ${rData.type ? 'bg-success' : 'bg-danger'}`}>
                        {rData.type ? t('PAID') : t('FAILED')}
                      </span>
                    </div>
                  </div>
                )}
              </Card.Body>

              <Card.Footer
                className='p-3'
                style={{
                  backgroundColor: White,
                  borderTop: '1px solid #f0f0f0'
                }}
              >
                <div className='d-grid gap-2'>
                  <Button
                    variant='primary'
                    className='py-2'
                    style={{
                      backgroundColor: GammaBlue,
                      borderColor: GammaBlue,
                      borderRadius: '10px',
                      fontWeight: 600
                    }}
                    onClick={() => {
                      window.location.href = '/dashboard';
                    }}
                  >
                    <GetIcon icon='FaHouse' style={{ marginRight: 8 }} />
                    {t('Go Back to Home Page')}
                  </Button>

                  {!rData.type && rData.getCurrentURL && (
                    <Button
                      variant='outline-danger'
                      className='py-2'
                      style={{ borderRadius: '10px', fontWeight: 600 }}
                      onClick={() => window.open(rData.getCurrentURL, '_self')}
                    >
                      {t('Retry')}
                    </Button>
                  )}
                </div>
              </Card.Footer>
            </Card>
          }

          {/* OPEN LINK FOR PAYMENT */}
          {(!rData && !isPageReady && !isPageError) &&
            <div className='m-3'>
              <Spinner animation='grow' variant='dark' />
            </div>
          }
          {(!rData && isPageReady && isPageError) &&
            <div className='m-3'>
              <Alert variant='danger'>{t('Incorrect details, please contact admin')}</Alert>
            </div>
          }
          {(!rData && isPageReady && !isPageError) &&
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ width: '100%', height: '100%' }}>
              {/* FOR EACH CENTER COPY AND PASTE PaymentCenterDefault IN A NEW FILE IN SAME FOLDER with the name "PaymentCenter`center_id`" and add a condition here*/}
              {this.renderCenterPaymentPage()}
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(PaymentGateway);


class PaymentNotConfigured extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    //let { params } = this.props
    return (
      <Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
        <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
          <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
        </Card.Header>
        <Card.Body>
          <Alert variant='danger'>
            <GetIcon icon="LuBadgeAlert" style={{ fontSize: 20, marginRight: 10 }} />
            Payment Gateway not configured, Contact Educore.
          </Alert>
        </Card.Body>
        <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
        </Card.Footer>
      </Card>
    )
  }
}

class PaymentCenterDefault extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    let { params } = this.props
    return (
      <Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
        <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
          <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
        </Card.Header>
        <Card.Body>
          <Table borderless striped>
            <thead>
              <tr>
                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>Summary</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style={{ textAlign: 'center' }}>Parent Name</th>
                <td style={{ textAlign: 'center' }}>{params.parent_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center' }}>Student Name</th>
                <td style={{ textAlign: 'center' }}>{params.child_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center' }}>Amount Due</th>
                <td style={{ textAlign: 'center' }}>{params.currencycode}{' '}{params.balance}</td>
              </tr>
            </tbody>
            <tfoot>
              {/* PAYMENT METHOD ICONS */}
              <tr>
                <td colSpan={2} style={{ textAlign: 'center', }}>
                  <div className='d-flex flex-row align-items-center justify-content-center'>
                    <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                  </div>
                </td>
              </tr>
            </tfoot>
          </Table>
        </Card.Body>
        <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
          <Button variant='primary' style={{ width: '100%' }}>
            <div className='d-flex flex-row justify-content-center align-content-center'>
              <div className='mx-1'>{t('Pay Now')}</div>
              <div className='mx-1' style={{ fontWeight: 600 }}>{params.currencycode}</div>
              <div className='mx-1 px-2' style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>{params.balance}</div>
            </div>
          </Button>
        </Card.Footer>
      </Card>
    )
  }
}
